<!-- <pos-app-spinner [show]="loading"></pos-app-spinner> -->

<div *ngIf="actionTaskDetailCard">
  <form [formGroup]="taskDetailCardForm" (submit)="submittaskDetailCardForm(true)">
    <div class="modal-header">
      <h4 class="modal-title">TASK SCHEDULE DETAILS</h4>
    </div>
    <div class="modal-body">
      <div class="border mb-2">
        <div class="row row-gap m-2">
          <div class="col-8 d-flex align-items-center">
            <label class="col-2">TASK DESCRIPTION</label>
            <div class="col-12 pr-2">
              <input class="form-control" formControlName="jobDescription" maxlength="80"/>
            </div>
          </div>
        </div>
        <div class="row row-gap m-2">
          <div class="col-4 d-flex align-items-center">
            <label class="col-4">TASK TYPE</label>
            <div class="col-7">
              <ng-select formControlName="jobTypeCode" [clearable]="false">
                <ng-option *ngFor="let jobType of jobTypeList" [value]="jobType.code">
                  {{ jobType.shortDescription }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-4 d-flex align-items-center">
            <label class="col-4"> DATE</label>
            <div class="col-7 pr-2">
              <input class="form-control" [value]="currentTaskData?.data?.WorkshopStartDate??currentDate" [readonly]="true" />
            </div>
          </div>
        </div>
        <div class="row row-gap m-2">
          <div class="col-4 d-flex align-items-center">
            <label  *ngIf="currentTaskData?.data?.JobOwner" class="col-4">JOB OWNER</label>
            <div class="col-7 pr-2">
              <input  *ngIf="currentTaskData?.data?.JobOwner" class="form-control" [value]="currentTaskData?.data?.JobOwner" [readonly]="true" />
            </div>
          </div>
          <div class="col-4 d-flex align-items-center">
            <label class="col-4">SCHEDULED HOURS</label>
            <div class="col-7 pr-2"><input class="form-control" formControlName="scheduledHours" [readonly]="true" /></div>
          </div>
          <div class="col-4 d-flex align-items-center">
            <div *ngIf="this.currentTaskData?.data?.JobID" class="col-10 pr-2">
              <button type="button" class="btn" (click)="viewScheduleHistory()">
                SCHEDULE HISTORY&nbsp;<span class="badge badge-light ml-2 bg-dark"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="row row-gap m-2">
          <div class="col-4 d-flex align-items-center">
            <label class="col-4"></label>
            <div class="col-7 pr-2"></div>
          </div>
        </div>
      </div>
      <div *ngIf="resourceList?.length > 0 || otherResourceList?.length > 0" class="border mb-2">
        <div class="row row-gap m-2">
          <div class="col-4 d-flex align-items-center">
            <label class="col-6">4X4 TECHNICIAN</label>
          </div>
          <div class="col-4 d-flex align-items-center">
            <label class="col-6">OTHER RESOURCES</label>
          </div>
        </div>
        <div class="row row-gap m-2">
          <div class="col-4 d-flex align-items-center">
            <div class="col-10 pr-2">
              <ng-multiselect-dropdown
                style="white-space: normal"
                [settings]="resourceSettings"
                [data]="technicianResourceList"
                formControlName="technicianResource"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-4 d-flex align-items-center">
            <div class="col-10 pr-2">
              <ng-multiselect-dropdown
                style="white-space: normal"
                [settings]="otherResourceSettings"
                [data]="otherResourceList"
                formControlName="otherResource"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="col d-flex float-end justify-content-end">
        <button class="btn btn-cancel mx-1 px-2" (click)="handleCloseModal(true)">CANCEL</button>
        <button class="btn text-white mx-1 px-2" type="submit" [disabled]="!taskDetailCardForm?.valid || !isFormValid">SAVE</button>
      </div>
    </div>
  </form>
</div>
<div *ngIf="scheduleTaskHistoryView">
  <div class="modal-header">
    <h4 class="modal-title">SCHEDULED HISTORY</h4>
  </div>

  <div class="modal-body">
    <label *ngIf="ledgerResultArray?.length < 0">NO LEDGER RECORDS FOUND</label>
    <div *ngIf="ledgerResultArray?.length > 0">
      <app-schedule-history-notes [ledgerResultArray]="ledgerResultArray" (closeActiveNoteModal)="handleCloseModal($event)">
      </app-schedule-history-notes>
    </div>
  </div>
  <button #closebutton class="btn btn-cancel m-3 float-end" (click)="handleCloseModal($event)">CLOSE</button>
</div>